$(document).ready(function() {
    /*
        Modale agganciato al banner commerciale
    */
    $('.modal-trigger').on('click', function(e){
        e.preventDefault();
        $('.modal-commercial').fadeIn();
		$(this).attr('tabindex', 0);
    });

    /*
        Modale sugli episodi di una serie
    */
    $('.episode').on('click', function(e){
        e.preventDefault();
        let cell = $(e.currentTarget);
        let target = $(cell.attr('data-modal'));
		target.fadeIn().attr('tabindex', 0).attr('aria-hidden', false).find('.close-btn').focus();

        let series_id = window.digitalData.page.category.subCategory;

        _satellite.track("popup-episodio", {
            eventProperties: {
                pageEvent: {
                    pageName: "programmi:" + series_id + ":popup-episodio",
                }
            }
        });
    });

    /*
        Chiusura modali
    */
    $('.modal-background').on('click', function(e){
        $(this).fadeOut();
		$(this).attr('tabindex', -1).attr('aria-hidden', true);
    });

    /*
        Modale con testo
    */
    $('body').on('click', '.more-text', function(e){
        e.preventDefault();
		var modalPlot = $(this).attr('data-target');
		$(modalPlot).fadeIn().attr('tabindex', 0).attr('aria-hidden', false).find('.close-btn').focus();
    });
});
